import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  Button,
  IButtonProps,
  HeaderText,
  Stack,
} from '../../../ui';
import { NotificationsAlertCircleIcon } from '../../../ui/Icons';
import { SnackbarState } from '../../../../store/Snackbar.model';

export type ActionProps = {
  id: string;
  text: string;
  onClick: (event: React.SyntheticEvent<EventTarget>) => void;
  appearance: IButtonProps['appearance'];
  snackbar?: Partial<SnackbarState>;
};

export type ApptCancelModalContentProps = {
  id: string;
  icon?: string;
  title: string;
  body?: string;
  actions: ActionProps[];
  onActionClick: (action: ActionProps, evt: React.SyntheticEvent<EventTarget>) => void;
};

export const ApptCancelModalContent: React.FC<ApptCancelModalContentProps> = ({
  id,
  icon,
  title,
  body,
  actions,
  onActionClick,
}) => {
  const alertIcon = (
    <NotificationsAlertCircleIcon
      color={colors.whiteWash}
      borderColor={colors.red}
      backgroundColor={colors.red}
    />
  );

  const icons = {
    'alert-icon': alertIcon,
  };

  return (
    <Stack alignItems="center" space={16} padding={24}>
      {icon && (
        <Box alignItems="center" testID={`${id} | icon`}>
          {icons[icon]}
        </Box>
      )}
      <Box alignItems="center" paddingBottom={8}>
        <HeaderText level={2} textAlign="center" testID={`${id} | title`}>
          {title}
        </HeaderText>
        <BodyText appearance="large" textAlign="center" testID={`${id} | body`}>
          {body}
        </BodyText>
      </Box>
      {actions.map(action => (
        <Button
          key={action.id}
          size="medium"
          style={{ textTransform: 'none' }}
          appearance={action.appearance}
          testID={`${id} | action: ${action.id}`}
          onClick={e => onActionClick(action, e)}
        >
          {action.text}
        </Button>
      ))}
    </Stack>
  );
};

ApptCancelModalContent.defaultProps = {};
